import React from "react";
import { LayoutA } from "components/layouts";
import { ResetPassword } from "modules";

const ResetPasswordPage = () => {
  return (
    <LayoutA>
      <ResetPassword />
    </LayoutA>
  );
};

export default ResetPasswordPage;
